export enum TypeMedia {
  THUMBNAIL = 'thumbnail',
  PREVIEW = 'cover',
  PROFILE = 'image',
}
